import {
    RoleDTO,
    IdentityClient_V1
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';
import ApiHelper from '../utils/ApiHelper';

export default class RoleService {
    private readonly _identityClient: IdentityClient_V1;

    constructor() {
        this._identityClient = new IdentityClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public GetRoles(): Promise<Array<RoleDTO>> {
        return this._identityClient.getRoles();
    }

    public SaveRole(dto: RoleDTO): Promise<RoleDTO> {
        if (dto.id) {
            return ApiHelper.ParseDTO<RoleDTO>(() => this._identityClient.updateRole(<string>dto.id, dto));
        }

        dto.isSystemRole = false;

        return ApiHelper.ParseDTO<RoleDTO>(() => this._identityClient.createRole(dto));
    }

    public DeleteRole(id: string) : Promise<RoleDTO> {
        return ApiHelper.ParseDTO<RoleDTO>(() => this._identityClient.deleteRole(id));
    }
}